// src/pages/.../utils/GameGrid.jsx

import React from "react";

export default function GameGrid({ game }) {
  const size = game.gridSize || 3;
  const cells = size * size;

  // Assumes your game stores collected correct emojis in `game.grid`
  const filled = game.grid || [];

  return (
    <div className="px-0.5 py-0.5">
      <div className="mb-1 flex items-center justify-between">
        <div className="font-black text-sm lg:text-lg text-cyan-300">
          🧩 Fill the Grid
        </div>

        <div className="text-sm text-slate-400">
          {filled.length} / {cells}
        </div>
      </div>

      <div
        className="grid gap-0.5 mx-auto w-fit"
        style={{
          gridTemplateColumns: `repeat(${size}, minmax(3rem, 4rem))`,
        }}
      >
        {Array.from({ length: cells }).map((_, index) => {
          const emoji = filled[index];

          return (
            <div
              key={index}
              className="
                h-12
                lg:h-16
                rounded-lg
                border
                border-slate-700
                bg-slate-900
                flex
                items-center
                justify-center
                text-4xl
                lg:text-6xl
                "
            >
              {emoji ? (
                emoji.char || emoji.emoji || emoji.symbol
              ) : (
                <span className="text-slate-700">⬜</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}